import { API_BASE_URL } from "src/config/api";
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Grid,
  Container,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import {
  AppNewsUpdate,
  AppOrderTimeline,
  LastFiveAlerts,
  UsageOverviewCard,
  TransactionCard,
  StatusOverview,
} from '../sections/@dashboard/app';
import useAccount from '../_mock/account';

export default function DashboardAppPage() {
  const account = useAccount();
  const [newsUpdateData, setNewsUpdateData] = useState([]);
  const [activityHistory, setActivityHistory] = useState([]);
  const isOldUser = account.isOldUser;

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/login';
      return;
    }

    const fetchNewsUpdate = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getAllNewsUpdate`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          setNewsUpdateData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching news updates:', error);
      }
    };

    const fetchActivityHistory = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getUserActivityById`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          setActivityHistory(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching activity history:', error);
      }
    };

    const fetchData = async () => {
      await Promise.all([
        fetchNewsUpdate(),
        fetchActivityHistory(),
      ]);
    };

    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title> Dashboard | WatchNod </title>
        <meta
          name="description"
          content="Welcome to the WatchNod Dashboard. Manage your subscription plans,user plan overview, monitor statuses, and stay updated with the latest news and activities."
        />
      </Helmet>

      <Container maxWidth="xl">
        {isOldUser && (
          <Typography variant="h3" gutterBottom>
            Welcome To WatchNod
          </Typography>
        )}

        {!isOldUser ? (
          <Box
            sx={{
              width: '100%',
              height: 'calc(100vh - 205px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(-45deg, #2065D1, #2186e3d6,rgb(196, 216, 253),rgb(175, 194, 221))',
              backgroundSize: '400% 400%',
              animation: 'gradientFlow 18s ease infinite',
              '@keyframes gradientFlow': {
                '0%': { backgroundPosition: '0% 50%' },
                '50%': { backgroundPosition: '100% 50%' },
                '100%': { backgroundPosition: '0% 50%' },
              },
            }}
          >
            <Container maxWidth="md">
              <Box
                sx={{
                  textAlign: 'center',
                  p: 6,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  boxShadow: '0px 6px 20px rgba(0,0,0,0.06)',
                }}
              >
                <RocketLaunchIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />

                <Typography variant="h3" fontWeight="bold" gutterBottom>
                  Welcome to WatchNod
                </Typography>

                <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                  This space will show your activity and stats.<br />
                  Start monitoring your Nodes & Domains in just a click.
                </Typography>

                <Button
                  variant="contained"
                  component={Link}
                  to="/dashboard/subscription"
                  size="large"
                  sx={{ px: 5, py: 1.5, fontWeight: 'bold', borderRadius: 1 }}
                >
                  Subscribe Now
                </Button>
              </Box>
            </Container>
          </Box>

        ) : (
          <>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} md={5} lg={5} xl={4}>
                <UsageOverviewCard />
              </Grid>
              <Grid item xs={12} md={7} lg={7} xl={8}>
                <StatusOverview />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} md={5} lg={5} xl={4}>
                <TransactionCard
                  title="Last 5 Transactions"
                  subheader="Overview of Recent Transactions"
                />
              </Grid>

              <Grid item xs={12} md={7} lg={7} xl={8}>
                <LastFiveAlerts />
              </Grid>

              <Grid item xs={12} md={5} lg={5} xl={4}>
                <AppOrderTimeline
                  title="Last 5 Activity"
                  subheader="Your recent activities and interactions on WatchNod."
                  list={activityHistory.map((data, index) =>
                    data
                      ? {
                        id: data._id,
                        title: data.activityTitle,
                        time: data.createdAt,
                      }
                      : {
                        id: `no-update-${index}`,
                        title: 'No Update',
                        time: new Date(),
                      }
                  )}
                />
              </Grid>

              <Grid item xs={12} md={7} lg={7} xl={8}>
                <AppNewsUpdate
                  title="News Update"
                  subheader="Latest insights, announcements, and platform updates."
                  list={newsUpdateData.map((data, index) => ({
                    id: data?._id || `no-update-${index}`,
                    title: data?.newsTitle || 'No Update',
                    description: data?.newsDescription || 'There is no update available.',
                    image: `/assets/images/covers/cover_${index + 1}.jpg`,
                    postedAt: new Date(data?.createdAt || new Date()),
                  }))}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </>
  );
}
